import React from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import App from './App';
import { useEffect } from 'react';

function DefaultRoute() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/');
    }, [navigate]);

    return null;
}

function Root() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="*" element={<DefaultRoute />} />
            </Routes>
        </Router>
    );
}

export default Root;